import { Button, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../utils/eventEmitter';
import useExpenseCategoryAPI from '../apis/expenseCategoryAPI';


const ExpenseCategoryChanges = () => {
  const { taxes, accounts, expenseCategory } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(expenseCategory.name ? expenseCategory.name : '');
  const { create, update } = useExpenseCategoryAPI();
  

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    console.log(data);
  };

  const edit = () => { 
    // let data = form.getFieldsValue();
    // data['name'] = name;
    // data['seo'] = name.toLowerCase().replace(/ /g, '-');
    // data['id'] = deliveryRegion.id;
    // update(deliveryRegion.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };

  useEffect(() => {
    EventEmitter.subscribe('expensecategories', data => {
      navigate('/expense/expense-categories/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('expensecategories');
    }
  },[])

  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/expense/expense-categories'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Expense Category</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ expenseCategory.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {expenseCategory.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          placeholder="Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={expenseCategory.seo ? {...expenseCategory, cost_price: expenseCategory.cost_price.$numberDecimal} : {cost_price: 0}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
              <Badge className="text-slate-500 ps-0 text-md bg-transparent border-b-2 mb-3">GENERAL INFORMATION</Badge>
              <Form.Item label='Cost' name='cost_price' className='font-semibold text-gray-800 mb-4' >
                <InputNumber className='input-outline-none font-normal w-full'/>
              </Form.Item>
              <Form.Item label='Internal Reference' name='internal_reference' className='font-semibold text-gray-800 mb-4' >
                <Input type='text' className='input-outline-none w-full font-normal' />
              </Form.Item>
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Badge className="text-slate-500 ps-0 text-md bg-transparent border-b-2 mb-3">ACCOUNTING</Badge>
              <Form.Item label='Expense Account' name='expense_account_id' className='font-semibold text-gray-800 mb-4' >
                <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='input-outline-none w-full font-normal'/>
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </div>
    </div>
  )
}

export default ExpenseCategoryChanges;